import React from 'react';
import Icon from 'components/AppIcon';

const AlertsSection = ({ alerts, title, translations }) => {
  const getAlertColor = (type) => {
    return type === 'ending_soon' ? 'yellow' : 'red';
  };

  const getAlertIcon = (type) => {
    return type === 'ending_soon' ? 'AlertTriangle' : 'XCircle';
  };

  const getAlertMessage = (alert) => {
    if (alert.type === 'ending_soon') {
      return `Subscription expires in ${alert.daysRemaining} ${translations.daysLeft}`;
    } else {
      return `Subscription expired ${alert.daysOverdue} days ago`;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
       {/* <button className="text-green-600 hover:text-green-700 text-sm font-medium">
          {translations.viewAll}
        </button>*/}
      </div>

      <div className="space-y-4">
        {alerts.map((alert) => (
          <div key={alert.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                getAlertColor(alert.type) === 'yellow' ?'bg-yellow-100 text-yellow-700' :'bg-red-100 text-red-700'
              }`}>
              
              </div>
              
              <div>
                <h4 className="font-medium text-gray-900">{alert.title}</h4>
                <p className="text-sm text-gray-600">{alert?.message}</p>
              </div>
            </div>

           {/* <button className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-medium">
              {translations.renewSubscription}
            </button>*/}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlertsSection;